import { Typography } from 'components';
import './index.scss';

const Policy = () => {
  return (
    <div className='policy'>
      <Typography variant='h1' bold>
        ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Ваша конфіденційність дуже важлива для нас. Ми хочемо, щоб ваша робота
          в Інтернеті була максимально приємною і корисною, і ви абсолютно
          спокійно використовували найширший спектр інформації, інструментів і
          можливостей, які пропонує Інтернет.
        </Typography>
        <Typography variant='body'>
          Ми створили "Політику конфіденційності", щоб продемонструвати свою
          вірність принципам конфіденційності та безпеки. У "Політиці
          конфіденційності" описано, як "ФОП Броварний Всеволод Віталійович"
          (далі "ZelenoHouse") збирає інформацію від усіх кінцевих користувачів
          своїх інтернет-послуг ("Послуг"), включно з людьми, які мають доступ
          до деяких наших послуг без реєстраційного запису ("Гостей"), а також
          клієнтами, які купили продукти та/або вносять щомісячну оплату за
          Послуги, щоб підписатися на Послугу ("Члени"). Політика також включає
          пояснення про те, що ми робимо із зібраною інформацією, і які
          можливості зі збору та використання такої інформації є у Гостей і
          Членів. Ми просимо вас ретельно ознайомитися з "Політикою
          конфіденційності".
        </Typography>
      </div>
      <Typography variant='h2'>
        Особиста інформація та шляхи її використання
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Членів можуть попросити надати певну особисту інформацію під час
          передплати наших Продуктів або Послуг, зокрема, ім'я, адресу, номер
          телефону, інформацію для виставлення рахунків (наприклад, номер
          кредитної картки) та тип персонального комп'ютера, що
          використовуватиметься для доступу до Послуг. Особиста інформація
          Членів, зібрана під час реєстрації (або в будь-який інший час),
          переважно використовується для підготовки Продуктів або Послуг
          відповідно до ваших потреб. Ваша інформація не буде передана або
          продана третім сторонам. Однак ми можемо частково розкривати особисту
          інформацію в особливих випадках, описаних у нижченаведеному розділі
          "Розголошення".
        </Typography>
      </div>
      <Typography variant='h2'>Розголошення</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Ми залишаємо за собою право розкривати інформацію Членів і Гостей
          наступним третім сторонам у таких ситуаціях:
        </Typography>
        <Typography variant='body'>
          Компаніям, що працюють від нашого імені: "ZelenoHouse" співпрацює з
          іншими компаніями, що виконують від імені "ZelenoHouse" функції
          бізнес-підтримки, у зв'язку з чим ваша особиста інформація може бути
          частково розкрита. Ми вимагаємо, щоб такі компанії використовували
          інформацію тільки з метою надання послуг за договором; їм
          забороняється передавати цю інформацію іншим сторонам у ситуаціях,
          відмінних від випадків, коли це викликано необхідністю надання
          обумовлених послуг. Приклади функцій бізнес-підтримки: виконання
          замовлень, реалізація заявок, видача призів і бонусів, проведення
          опитувань серед клієнтів та управління інформаційними системами. Ми
          також розкриваємо узагальнену неперсоніфіковану інформацію при виборі
          постачальників послуг.
        </Typography>
        <Typography variant='body'>
          При передачі контролю над підприємством: "ZelenoHouse" складає за
          собою право передавати ваші анкетні дані у зв'язку з повним або
          частковим продажем або трансфертом нашого підприємства або його
          активів. Під час продажу або трансферту бізнесу "ZelenoHouse" надасть
          вам можливість відмовитися від передачі інформації про себе. У деяких
          випадках це може означати, що нова організація не зможе надалі
          надавати вам послуги або продукти, які раніше надавалися
          "ZelenoHouse".
        </Typography>
        <Typography variant='body'>
          Правоохоронним органам: "ZelenoHouse" може без вашої на те згоди
          розкривати персональну інформацію третім сторонам із будь-якої з
          наступних причин: для уникнення порушень закону, нормативних правових
          актів або постанов суду; участь в урядових розслідуваннях; допомога в
          запобіганні шахрайству; а також зміцнення або захист прав
          "ZelenoHouse" або дочірніх підприємств.
        </Typography>
        <Typography variant='body'>
          З вашої згоди: У всіх інших випадках перед передачею інформації про
          вас третім сторонам "ZelenoHouse" зобов'язується отримати вашу явну
          згоду. Наприклад, "ZelenoHouse" може реалізовувати спільну пропозицію
          або конкурс з третьою стороною, тоді ми попросимо у вас дозвіл на
          спільне використання вашої особистої інформації з третьою стороною.
        </Typography>
      </div>
      <Typography variant='h2'>Інтернет покупки</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          При замовленні послуг або продуктів безпосередньо у "ZelenoHouse"
          надана вами персональна інформація використовується для обробки даного
          замовлення. Ми не передаємо цю інформацію стороннім організаціям, за
          винятком випадків, коли це необхідно для виконання такого замовлення.
        </Typography>
        <Typography variant='body'>
          Під час подачі замовлення через інші компанії, які можуть давати
          посилання на наші сайти, наприклад, пропонуючи подарунок через
          Інтернет, який безпосередньо надсилається одержувачу, вас можуть
          попросити надати інформацію про одержувача, зокрема, ім'я, адресу та
          номер телефону. "ZelenoHouse" ніяк не контролює шляхи використання
          третіми сторонами персональної інформації, наданої вами під час
          розміщення таких замовлень. Будь ласка, у таких випадках будьте
          обережні. Рекомендуємо ознайомитися з політикою конфіденційності та
          правилами користування будь-яких інших компаній, на чиї веб-сайти
          можна перейти з наших сайтів.
        </Typography>
      </div>
      <Typography variant='h2'>Реклама в інтернеті</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          "ZelenoHouse" може розміщувати рекламу в Інтернеті. У таких випадках
          ми надаємо своїм рекламодавцям згруповану і неперсоніфіковану
          інформацію про своїх Гостей і Членів, зібрану під час реєстрації, а
          також за допомогою інтернет-опитувань і заходів з просування.
        </Typography>
        <Typography variant='body'>
          Крім того, в деяких випадках ми використовуємо цю згруповану і
          неперсоніфіковану інформацію для цільової реклами та спільних
          підприємств. Наприклад, рекламодавець або спільне підприємство
          говорить, до якої аудиторії потрібно достукатися, і надає відповідну
          їй рекламу. Пізніше на підставі зібраної та згрупованої
          неперсоніфікованої інформації ми розміщуємо або розсилаємо рекламу
          цільовій аудиторії. "ZelenoHouse" не розкриває таким рекламодавцям або
          спільним підприємствам персональну інформацію про своїх Гостей і
          Членів. Інформація про те, як відмовитися від інтернет-реклами
          "ZelenoHouse" включається безпосередньо в рекламні матеріали.
        </Typography>
      </div>
      <Typography variant='h2'>
        Відповіді на електронні запитання та запити
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Коли Гості або Члени надсилають нашій компанії електронні запити, для
          відповіді на них використовується електронна адреса, з якої надійшов
          запит. "ZelenoHouse" не використовує зворотні адреси в будь-яких інших
          цілях і не передає їх будь-яким третім сторонам.
        </Typography>
      </div>
      <Typography variant='h2'>Добровільні опитування клієнтів</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Ми періодично проводимо як комерційні, так і приватні опитування серед
          користувачів. Ми рекомендуємо своїм клієнтам брати участь у цих
          опитуваннях, оскільки вони дають нам важливу інформацію, за допомогою
          якої ми можемо покращити різноманітні свої продукти та послуги, а
          також удосконалити шляхи їх надання. Ваша особиста інформація та
          відповіді залишаться суворо конфіденційними навіть при проведенні
          опитування третьою стороною. Участь у наших клієнтських опитуваннях не
          обов'язкова. Інформація про те, як відмовитися від участі в
          опитуванні, включається в повідомлення про опитування.
        </Typography>
        <Typography variant='body'>
          Ми можемо взяти інформацію, отриману від окремих осіб, які беруть
          участь у наших клієнтських опитуваннях, та об'єднати (згрупувати) з
          відповідями інших наших клієнтів для створення ширших та узагальнених
          відповідей на запитання опитування (зокрема, стать, вік, місце
          проживання, захоплення, освіта, місце роботи, сектор промисловості та
          ін. демографічна інформація). Після цього згрупована інформація
          використовується для поліпшення якості послуг, що надаються вам, і
          розробки нових послуг і продуктів. Така згрупована та
          неперсоніфікована інформація може передаватися третім сторонам.
        </Typography>
      </div>
      <Typography variant='h2'>Автоматичний збір інформації</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Cookies: Для збору інформації "ZelenoHouse" може користуватися
          маркерами Cookies; це маленькі інформаційні файли, які зберігаються
          вашим браузером на жорсткому диску вашого комп'ютера на вимогу
          веб-сайту. Маркери Cookies "ZelenoHouse" не містять будь-якої
          персональної інформації та переважно використовуються таким чином:
        </Typography>
        <Typography variant='body'>
          - для відстеження часової інформації. Наприклад, маркери Cookies дають
          нам змогу відстежувати, які картинки ви завантажуєте та завантажуєте;
        </Typography>
        <Typography variant='body'>
          - щоб реєструвати вас у спеціальних програмах. Cookies дають нам змогу
          запам'ятовувати вас під час входу в зони нашого сайту, для яких
          необхідно бути Членом; щоб запам'ятати ваші уподобання щодо країни та
          мови;
        </Typography>
        <Typography variant='body'>
          - щоб допомогти нам зрозуміти масштаби своєї аудиторії і розподіл
          трафіку; для збору і запису інформації про те, що ви переглянули на
          нашому сайті і що переглянули в нашому електронному листі;
        </Typography>
        <Typography variant='body'>
          - для управління інформацією сайту та її презентації, а також щоб
          зрозуміти, які зображення можуть відображатися на вашому комп'ютері, і
          подавати інформацію відповідно до ваших інтересів
        </Typography>
        <Typography variant='body'>
          Веб-маяки: Ми також можемо розміщувати на своєму веб-сайті, в
          інтернет-рекламі за участю третіх сторін і своїх електронних листах
          невеликі "зображення, що стежать" або "маяки". Такі маяки
          застосовуються разом з маркерами Cookies для збору неособистої
          інформації про використання нашого сайту, зокрема, включно з часом і
          датою відвідування, переглянутими сторінками, сторінкою переходу,
          типом браузера (наприклад, Internet Explorer, NetScape), типом
          операційної системи (наприклад, Windows, Linux або Mac), а також ім'ям
          домену провайдера інтернет-послуг відвідувача (наприклад, AOL). Ми
          збираємо таку інформацію про відвідування сайту тисячами і аналізуємо
          в цілому. Ця інформація важлива, зокрема, для визначення ефективності
          нашої інтернет-реклами, наприклад, банерів і вибору місця для
          майбутньої реклами на інших веб-ресурсах.
        </Typography>
        <Typography variant='body'>
          Вимкнення Cookies і маяків: Якщо збір такої інформації через маркери
          Cookies і маяки вам неприємний, рекомендуємо вимкнути ці функції в
          налаштуваннях свого браузера, але, будь ласка, пам'ятайте, що це
          обмежить ефективність і функціональність веб-сайтів нашої Компанії.
          Про те, як відключити підтримку cookie і маяків, як правило, йдеться в
          інструкції до браузера.
        </Typography>
      </div>
      <Typography variant='h2'>Інформаційний захист дітей</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Захист дітей від інтернет-інформації особливо важливий.
        </Typography>
        <Typography variant='body'>
          Дітям молодше 14 років не дозволяється користуватися нашим сайтом,
          вони не повинні реєструватися і надавати будь-яку особисту інформацію
          на ньому. Підліткам 14-17 років не слід надсилати особисту інформацію
          через Інтернет (у тому числі нам), попередньо не проконсультувавшись
          зі своїми батьками.
        </Typography>
        <Typography variant='body'>
          "ZelenoHouse" навмисно не дозволяє дітям до 14 років ставати
          зареєстрованими членами наших сайтів або купувати товари та послуги на
          наших сайтах без підтвердженого дозволу від батьків. "ZelenoHouse"
          навмисно не збирає і не запитує особисту інформацію у дітей до 14
          років без явної на те згоди їхніх батьків.
        </Typography>
        <Typography variant='body'>
          Якщо ми коли-небудь включимо дітей до 14 років до числа цільової
          аудиторії наших сайтів, то ці спеціальні сторінки будуть виділені
          окремо і міститимуть розгорнуте повідомлення про конфіденційність,
          відповідно до положень Акту про захист приватного життя дитини в
          Інтернеті (COPPA); ми також забезпечимо механізми отримання дозволу
          батьків, їхній доступ до інформації та дамо батькам можливість
          вимагати видалення особистої інформації своїх дітей.
        </Typography>
        <Typography variant='body'>
          "ZelenoHouse" вітає батьків і опікунів, які проводять час у мережі
          разом зі своїми дітьми та беруть участь у їхніх інтерактивних заняттях
          і захопленнях.
        </Typography>
      </div>
      <Typography variant='h2'>Громадські форуми</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Певна частина наших сайтів може надавати доступ до суспільних послуг,
          зокрема, дощок обговорення, чатів і заходів у режимі реального часу.
          Користуючись такими послугами, будь ласка, будьте обережні, коли
          публікуєте інформацію про себе. Врахуйте, що особиста інформація,
          розкрита на таких сайтах, наприклад, ваше ім'я, ім'я користувача,
          адреса електронної пошти тощо, може збиратися та використовуватися для
          несанкціонованих розсилок. Такі послуги відкриті для громадського
          користування, і те, що ви публікуєте там, може переглядати будь-хто -
          інформація не захищена. Ми не в змозі контролювати коментарі, які ви
          можете отримати, беручи участь у таких послугах. Коментарі інших людей
          можуть здатися вам образливими, небезпечними або некоректними.
        </Typography>
      </div>
      <Typography variant='h2'>
        Прихильність принципам кофідиціальності
      </Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          Для захисту вашої особистої інформації ми використовуємо різноманітні
          адміністративні, управлінські та технічні заходи безпеки.
          "ZelenoHouse" дотримується різних міжнародних стандартів контролю,
          спрямованих на операції з особистою інформацією, які включають певні
          заходи контролю щодо захисту інформації, зібраної в Інтернеті. Наших
          співробітників навчають розуміти і виконувати ці заходи контролю, вони
          ознайомлені з нашою "Політикою конфіденційності", нормами та
          інструкціями. Проте, незважаючи на те, що ми прагнемо убезпечити вашу
          особисту інформацію, ви теж повинні вживати заходів, щоб захистити її.
          Ми наполегливо рекомендуємо вам вживати всіх можливих запобіжних
          заходів під час перебування в інтернеті.
        </Typography>
        <Typography variant='body'>
          Організовані нами послуги та веб-сайти передбачають заходи щодо
          захисту від витоку, несанкціонованого використання та зміни
          інформації, яку ми контролюємо. Незважаючи на те, що ми робимо все
          можливе, щоб забезпечити цілісність і безпеку своєї мережі та систем,
          ми не можемо гарантувати, що наші заходи безпеки допоможуть запобігти
          незаконному доступу до цієї інформації хакерів сторонніх організацій.
        </Typography>
      </div>
      <Typography variant='h2'>Електронні розсилки</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          "ZelenoHouse" має право здійснювати електронні розсилки новин,
          інформації про спеціальні пропозиції та акції, а також надсилати
          індивідуальні відповіді на звернення своїх клієнтів.
        </Typography>
        <Typography variant='body'>
          У будь-який момент користувачі можуть відмовитися від розсилок,
          перейшовши за відповідним посиланням внизу будь-якого з отриманих
          листів. Також користувач може відписатися від розсилки, надіславши
          листа з цією вимогою на електронну адресу: ZelenoHouseInfo@gmail.com
        </Typography>
      </div>
      <Typography variant='h2'>Зміни цієї політики</Typography>
      <div className='policy-block'>
        <Typography variant='body'>
          "ZelenoHouse" залишає за собою право в будь-який час і будь-яким чином
          редагувати, доповнювати або змінювати цю політику, а також інші
          політики і договори, оновивши при цьому цю сторінку.
        </Typography>
      </div>
    </div>
  );
};

export default Policy;
